import { useEffect, useState } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import * as server from './server';

export const useBonusBuyInTemplate = ({ bonusCode }) => {
    const translate = useTranslations('playtech.mobile.system.');
    const [bonusTemplate, setBonusTemplate] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setIsLoading(true);

            try {
                const response = await server.getBonusTemplate({ bonusCodes: [bonusCode] });
                const { bonusTemplates } = response.data;

                if (bonusTemplates.length === 0) {
                    setBonusTemplate(null);
                    setError(translate('error'));
                    return;
                }

                setBonusTemplate(bonusTemplates[0]);
                setError(null);
            } catch (e) {
                setBonusTemplate(null);
                setError(translate('error'));
            } finally {
                setIsLoading(false);
            }
        })();
    }, [bonusCode, translate, setError, setIsLoading]);

    return { bonusTemplate, error, isLoading };
};
